<template>
  <v-container fluid class="ma-0 pa-0" style="background: linear-gradient(#043339, #fff);">
    <!-- DESKTOP -->
    <v-container
      fluid
      class="d-none d-lg-block top-image"
      style="height: 90vh;"
    >
      <v-card class="transparent elevation-0" style="top: 25%; background: transparent !important;">
        <v-card-text>
          <v-img
            class="mt-2"
            style="margin: auto; display: block;"
            src="@/assets/logos/logo_final_whitetext_Prancheta 1.svg"
            lazy-src="@/assets/logos/logo_final_whitetext_Prancheta 1.svg"
            width="20%"
          />
        </v-card-text>

        <v-card-text class="text-center primary--text text-h4 font-weight-bold">
          {{ $t('success.title') }}
        </v-card-text>

        <v-card-text
          class="text-center tertiary--text font-weight-bold text-h5"
          v-html="$t('success.msg')"
        />

        <v-card-text>
          <v-container
            fluid
            fill-height
            class="d-flex justify-center tertiary--text"
            style="white-space: pre-line;"
          >
            <table>
              <tbody>
                <tr>
                  <td></td>
                  <td>
                    <div class="text-h6 font-weight-medium">
                      {{ $t('PRE_FOOTER.contacts') }}
                    </div>
                  </td>
                </tr>
                <tr class="text-caption font-weight-light" style="font-family: Montserrat;">
                  <td><v-icon size="x-small" color="tertiary">mdi-email</v-icon></td>
                  <td>info@dreamdealtech.com</td>
                </tr>
                <tr class="text-caption font-weight-light" style="font-family: Montserrat;">
                  <td><v-icon size="x-small" color="tertiary">mdi-clock</v-icon></td>
                  <td>{{ $t('PRE_FOOTER.work_week') }} - 9h {{ $t('PRE_FOOTER.to') }} 18h</td>
                </tr>
                <tr class="text-caption font-weight-light" style="font-family: Montserrat;">
                  <td><v-icon size="x-small" color="tertiary">mdi-phone</v-icon></td>
                  <td>+351 220 280 430</td>
                </tr>
              </tbody>
            </table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- MOBILE -->
    <v-container fluid class="d-lg-none top-image py-16">
      <v-card class="transparent elevation-0 py-16" style="top: 55%; background: transparent !important;">
        <v-card-text class="py-16">
          <v-img
            class="mt-2"
            style="margin: auto; display: block;"
            src="@/assets/logos/logo_final_whitetext_Prancheta 1.svg"
            lazy-src="@/assets/logos/logo_final_whitetext_Prancheta 1.svg"
            width="70%"
          />
        </v-card-text>

        <v-card-text class="text-center primary--text text-h6 font-weight-bold">
          {{ $t('success.title') }}
        </v-card-text>

        <v-card-text
          class="text-center tertiary--text font-weight-bold text-h6"
          v-html="$t('success.msg')"
        />

        <v-card-text>
          <v-container
            fluid
            fill-height
            class="d-flex justify-center tertiary--text"
            style="white-space: pre-line;"
          >
            <table>
              <tbody>
                <tr>
                  <td></td>
                  <td>
                    <div class="text-h6 font-weight-medium">
                      {{ $t('PRE_FOOTER.contacts') }}
                    </div>
                  </td>
                </tr>
                <tr class="text-caption font-weight-light" style="font-family: Montserrat;">
                  <td><v-icon size="x-small" color="tertiary">mdi-email</v-icon></td>
                  <td>info@dreamdealtech.com</td>
                </tr>
                <tr class="text-caption font-weight-light" style="font-family: Montserrat;">
                  <td><v-icon size="x-small" color="tertiary">mdi-clock</v-icon></td>
                  <td>{{ $t('PRE_FOOTER.work_week') }} - 9h {{ $t('PRE_FOOTER.to') }} 18h</td>
                </tr>
                <tr class="text-caption font-weight-light" style="font-family: Montserrat;">
                  <td><v-icon size="x-small" color="tertiary">mdi-phone</v-icon></td>
                  <td>+351 220 280 430</td>
                </tr>
              </tbody>
            </table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>
  </v-container>
</template>

<style>
.linear-success {
  background: linear-gradient(#043339, #fff);
}
.top-image {
  background-image: url('../assets/covers/topo.svg');
  background-repeat: no-repeat;
  background-size: 100%;
  margin-top: -5%;
}
</style>
